import React from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";


import logo from "../asserts/Screenshot 2025-02-26 151051.png";
import adImage1 from "../asserts/advertisement1.png";
import adImage2 from "../asserts/advertisment2.jpg";
import adImage3 from "../asserts/advertisement3.jpeg";

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Hero Section */}
      <header className="hero-section">
        <div className="top-bar">
          <img src={logo} alt="Earnova Logo" className="logo" />
          <button className="sign-in-button" onClick={() => navigate("/login")}>
            Login
          </button>
        </div>

        <div className="hero-content">
          <h1>Simple Ways to Make Money Online</h1>
          <p>Turn your spare time into earnings today. Play games, take surveys, and explore other easy ways to make money online with JumpTask..</p>
          <button className="cta-button" onClick={() => navigate("/signup")}>
            Get Started
          </button>
        </div>
      </header>

      {/* Features Section */}
      <section className="features-section">
        <h2>How It Works</h2>
        <div className="features">
          <div className="feature">
            <img src={adImage1} alt="Watch Ads" />
            <h3>Watch Ads</h3>
            <p>Earn money just by watching short ads.</p>
          </div>
          <div className="feature">
            <img src={adImage2} alt="Complete Tasks" />
            <h3>Complete Tasks</h3>
            <p>Complete simple tasks to boost your earnings.</p>
          </div>
          <div className="feature">
            <img src={adImage3} alt="Earn More" />
            <h3>Earn More</h3>
            <p>More tasks, more rewards, the more you earn!</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; 2025 Earnova. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default LandingPage;
